export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestern"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heute"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Montag"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dienstag"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mittwoch"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Donnerstag"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Freitag"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Samstag"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sonntag"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Januar"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Februar"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["März"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["April"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mai"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juni"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juli"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["August"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["September"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oktober"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["November"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezember"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sie"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrator"])}
}